import { fromJS } from 'immutable';

import { ApiListTemplate, UserToken } from '../../../helper/HelperAuth'
import doFetch from '../../../infra/helper/fetchHelper'

export default (templateid) => async (dispatch, getState) => {
    
    const Authorization = UserToken;
    
    const url = ApiListTemplate + 'config-hsmtemplate-view';

    var paramBody = {"data": {"template-id" : templateid}}
    
    const argument = {  
        method: 'POST',
        headers : {
            'Content-Type':'application/json',
            'Authorization': Authorization,
        },
        body : JSON.stringify(paramBody)
    }; 

    const response = await doFetch(url,argument);
    var data = fromJS({});
    if(response.ok){
        data = fromJS({});

        try{
            var resJson = await response.json()
            if(resJson !== '' || resJson !== null){
                data = fromJS(resJson);
                data = data.get('query-result');
            }else{
                data = fromJS({});
            }    
        }catch(ex){
            data = fromJS({});
        }
    }

    return data;
};